import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getAcceptanceIssues = createAsyncThunk(
  'acceptanceIssues/getAcceptanceIssues',
  async (formData = {}, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/co/acceptance_issues', { params: { ...formData } });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export default getAcceptanceIssues;
